import axios from 'axios';
import { API_ENDPOINTS } from './endopoints'; // Adjust the path as necessary

class ReportsService {
  async getReportsPayments() {
    try {
      const response = await axios.get(`${API_ENDPOINTS.getReportsPayment}/52`, this.getHeaders());
      return response.data;
    } catch (error) {
      console.error('Error getting reports:', error);
    }
  }
  async getReportsActivity() {
    try {
      const response = await axios.get(`${API_ENDPOINTS.getReportsActivity}/52`, this.getHeaders());
      return response.data;
    } catch (error) {
      console.error('Error getting reports:', error);
    }
  }
  async saveReportsPayment(data: any) {
    try {
      const response = await axios.post(
        API_ENDPOINTS.saveReportsPayment,
        { data: data },
        this.getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Error getting reports:', error);
    }
  }
  async saveReportsActivity(data: any) {
    try {
      const response = await axios.post(
        API_ENDPOINTS.saveReportsActivity,
        { data: data },
        this.getHeaders()
      );
      return response.data;
    } catch (error) {
      console.error('Error getting reports:', error);
    }
  }
  getHeaders() {
    // Implement logic to get the necessary headers, e.g., authorization token
    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    };
  }
}
export default new ReportsService();
